const functionImplContext = {
    tables : {
      ccy : { GB : "GBP", US: "USD" },
      code: { 301: { value: 301, description: "General Residential" },}
    },

    lookup : (s,table) => {
      return functionImplContext.tables[table][s];
    },

    upper : s => s.toUpperCase(),
    lower : s => s.toLowerCase(),
  }

const functionsLower = {
   left:        (s,n)      => (()=>s.substring(0,n))(),
   mid:         (s,n,m)    => s.substring(n,n+m),
   right:       (s,n)      => s.substring(s.length-n),
   lookup:      (s,table)  =>functionImplContext.lookup(s,table),
   upper:       (s)        =>functionImplContext.upper(s),
   lower:       (s)        =>functionImplContext.lower(s),
   split:       (s,delim=" ")=>s.split(delim),
   item:        (a,i)      => a[i], 
   round:       (a)        => Math.round(a),
   ceil:        (a)        => Math.ceil(a),
   floor:       (a)        => Math.floor(a),
   trunc:       (a)        => Math.trunc(a),
   abs:         (a)        => Math.abs(a),
   trim:        (s)        => s.trim(),
   contains:    (s,x)      => s.indexOf(x) > -1,
   replace:     (s,x,y)    => s.replace(new RegExp(x),y),
   replaceAll:  (s,x,y)    => s.replace(new RegExp(x,"g"),y),
   zeroPad:     (s,n)      => ("00000000000000000000"+s).substring(20+(""+s).length-(n || 0)),
   spacePad:    (s,n)      => ("                    "+s).substring(20+(""+s).length-(n || 0)),
   count:       (obj,key)  => { 
    //  console.log("exp.count in", obj, key); 
     var count = (obj[key] || 0); 
     count++; 
     obj[key] = count; 
    //  console.log("exp.count out", obj, key, count); 
     return count; 
   }
}

const functionsUpper = Object.entries(functionsLower)
    .map(kv => ([kv[0].toUpperCase(),kv[1]]))
    .reduce((o,kv)=>(o[kv[0]]=kv[1],o),{})

const functions = {...functionsLower, ...functionsUpper};

exports.functionImpl = functions;
